import { useInjectedConnectors } from '@starknet-react/core';

export function useInstalledStarknetWallets() {
  // Discovers the list of injected Starknet connectors installed by the user.
  const { connectors } = useInjectedConnectors({});
  return connectors.length > 0
    ? connectors.map((connector) => connector.name).join(', ')
    : null;
}
